import React from 'react';
import { DesignCanvasLayer } from 'models/cms/booths';
import GenericCMSBoothBanner from 'pages/booths/components/GenericCMSBoothBanner';
import StyledContainer from '../styled';

interface ElementProps {
  layer: DesignCanvasLayer;
  isPreview: boolean;
  boothVideoAutoplay: boolean;
  onElementClick: () => void;
}

const Element: React.FC<ElementProps> = ({
  layer, isPreview, onElementClick, boothVideoAutoplay,
}: ElementProps) => {
  const {
    positionX, positionY, height, width,
  } = layer;

  return !!layer && (
    <StyledContainer width={width} height={height} positionX={positionX} positionY={positionY} onClick={onElementClick}>
      <GenericCMSBoothBanner bannerData={layer} isPreview={isPreview} autoPlayVideo={boothVideoAutoplay} />
    </StyledContainer>
  );
};

export default Element;
